<template>
  <div class="maccontainer _maccontainer">
    <doorList :newStyle="newStyle"></doorList>
  </div>
</template>

<script>
import doorList from '@/components/doorList'
export default {
  name: 'courtyardGloryDoor',
  components:{
    doorList
  },
  data() {
    return {
      newStyle: [
        {
          id: 1,
          name: '2022荣耀庭院门',
          title: '新款',
          img: require('../../assets/luxuryArmourDoor/newStyle.png'),
          listImg: [
            {
              id: 1,
              imgLink: require('../../assets/courtyardGloryDoor/courtyardGloryDoor1.jpg'),
              understand: true,
            },
            {
              id: 3,
              imgLink: require('../../assets/courtyardGloryDoor/courtyardGloryDoor3.jpg'),
              understand: false,
            },
            {
              id: 4,
              imgLink: require('../../assets/courtyardGloryDoor/courtyardGloryDoor4.jpg'),
              understand: false,
            },
            {
              id: 5,
              imgLink: require('../../assets/courtyardGloryDoor/courtyardGloryDoor5.jpg'),
              understand: false,
            },
            {
              id: 2,
              imgLink: require('../../assets/courtyardGloryDoor/courtyardGloryDoor2.jpg'),
              understand: false,
            },
          ]
        }
      ]
    }
  },
}
</script>

<style lang="less" scoped>

// 大于800px
@media only screen and (min-width: 800px){
    .maccontainer{
    }
}

// 小于800px
@media only screen and (max-width: 800px){
    ._maccontainer{
    }
}
</style>



// WEBPACK FOOTER //
// src/page/courtyardGloryDoor/courtyardGloryDoor.vue